// removed by extract-text-webpack-plugin
module.exports = {"footer":"_36jnNcMXMOz83zHoRu9LWM","dots":"_1sfNdYGK_ig-L74x2uaZPE","copyright":"_25Lm8uxa1p-9-4uqKOz3Tl"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/layout/Footer.css
// module id = 429
// module chunks = 0